import React, { FC } from "react";

type AvatarProps = {
  size?: number;
  email: string;
};

// El hash y el label se usan para determinar el color de fondo
function stringToHashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
      const char = str.codePointAt(i) ?? 0;
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convertir a entero de 32 bits
  }
  return hash;
}

function hashCodeToHexColor(hash: number) {
  const r = Math.abs((hash & 0xFF0000) >> 16);
  const g = Math.abs((hash & 0x00FF00) >> 8);
  const b = Math.abs(hash & 0x0000FF);

  const maxColorValue = 200;
  const color = `#${(r % maxColorValue).toString(16).padStart(2, '0')}${(g % maxColorValue).toString(16).padStart(2, '0')}${(b % maxColorValue).toString(16).padStart(2, '0')}`;
  return color;
}

function getDeterministicColor(initials: string, length: number) {
  const hash = stringToHashCode(initials + length.toString());
  return hashCodeToHexColor(hash);
}

export const Avatar: FC<AvatarProps> = React.memo(({ size = 40, email }) => {
  // Lógica para obtener las iniciales del email
  let emailName = email.split("@")[0];
  let emailLength = email.length;
  let emailSplitted = emailName.split(".");
  let emailInitials;

  if (emailSplitted.length > 1) {
    emailInitials = (emailSplitted[0].charAt(0) + emailSplitted[1].charAt(0)).toUpperCase();
  } else {
    emailInitials = emailSplitted[0].charAt(0).toUpperCase();
  }

  const bgColor = getDeterministicColor(emailInitials, emailLength);

  // Estilos equivalentes a los de MuiAvatar
  const avatarStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: bgColor,
    color: "#fff",
    fontSize: `${size * 0.4}px`,
    borderRadius: "8px",
    fontWeight: "bold",
    fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`,
    userSelect: "none",
  };

  return (
    <div style={avatarStyle} title={email}>
      {emailInitials}
    </div>
  );
});

Avatar.displayName = "Avatar";
